module.exports = __webpack_public_path__ + "static/media/filter.d55d5e48.svg";